import {
  Box,
  Button,
  useTheme,
  Typography,
  useMediaQuery,
} from "@mui/material";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";

const GlobalCookies = () => {
  const [showBanner, setShowBanner] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    const consent = Cookies.get("cookie_consent");
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    Cookies.set("cookie_consent", "true", { expires: 365 });
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        width: "100%",
        backgroundColor: "#333",
        color: "#fff",
        py: 2,
        zIndex: 1300,
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        justifyContent: "space-between",
        alignItems: isMobile ? "flex-start" : "center",
        gap: 2,
      }}
    >
      <Typography
        variant="body2"
        sx={{
          flex: "1 1 auto",
          fontSize: "14px",
          lineHeight: 1.6,
          marginLeft: 5,
        }}
      >
        This website uses cookies to ensure you get the best experience.
      </Typography>

      <Button
        onClick={handleAccept}
        variant="contained"
        sx={{
          backgroundColor: "#fff",
          color: "#333",
          "&:hover": { backgroundColor: "#e0e0e0" },
          fontSize: "14px",
          textTransform: "none",
          marginRight: 5,
        }}
      >
        Accept
      </Button>
    </Box>
  );
};

export default GlobalCookies;
